
import React from "react";

const ClearInputIcon = (props) => {

    return (
      <React.Fragment>
        <div>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99967 0.333374C3.31301 0.333374 0.333008 3.31337 0.333008 7.00004C0.333008 10.6867 3.31301 13.6667 6.99967 13.6667C10.6863 13.6667 13.6663 10.6867 13.6663 7.00004C13.6663 3.31337 10.6863 0.333374 6.99967 0.333374ZM10.333 9.39337L9.39301 10.3334L6.99967 7.94004L4.60634 10.3334L3.66634 9.39337L6.05967 7.00004L3.66634 4.60671L4.60634 3.66671L6.99967 6.06004L9.39301 3.66671L10.333 4.60671L7.93967 7.00004L10.333 9.39337Z" fill="#E71D36"/>
        </svg>
        </div>
      </React.Fragment>
    )
}

export default ClearInputIcon;



